module.exports = __webpack_public_path__ + "static/media/grains_2.e2d42c4c.png";